import React from 'react';
import css from './SectionMaxWeight.css';
import { EditComponent } from '..';
import { IconWeight } from '../../../../icons';
import { Button } from '../../../../components';

export default ({
    publicData,
    isOwnListing,
    editParams,
    authorDisplayName,
    isLoggedOut,
    isDraftVariant,
}) => {
    const { maxWeight } = publicData;
    const noData = !maxWeight;

    if (isLoggedOut && noData) return null;

    const showNoDataForLoggedInViewer =
        (isDraftVariant || (!isOwnListing && !isLoggedOut)) && noData;
    const showAddNewItemButton = !isDraftVariant && isOwnListing && noData;
    const editAllowed = !isDraftVariant && !noData && isOwnListing;

    const dataAvailable = !noData && (
        <p className={css.sectionMaxWeight}>
            <IconWeight />
            {maxWeight} kg
        </p>
    );

    const placeholderForLoggedInViewer = showNoDataForLoggedInViewer && (
        <p>{authorDisplayName} hat kein Maximalgewicht hinzugefügt.</p>
    );

    const content = dataAvailable || placeholderForLoggedInViewer;

    return (
        <div className={css.root}>
            <h2 className={css.sectionTitle}>
                <span>Maximalgewicht</span>
                {editAllowed ? (
                    <EditComponent pageName="experience" editParams={editParams} hideText={true} />
                ) : null}
            </h2>
            <div>{content}</div>
            {showAddNewItemButton && (
                <EditComponent
                    pageName="experience"
                    editParams={editParams}
                    rootClassName={css.addNewItemButton}
                >
                    <Button>Maximalgewicht hinzufügen</Button>
                </EditComponent>
            )}
        </div>
    );
};
